import { Card, Text } from '@comicrelief/component-library';
import { RichTextConverter } from '@/services/richtextConverter/richtextConverter';
import {
  Wrapper,
  BlurbWrapper,
  Title,
  Grid,
  Items
} from './FooterCards.style';

import { FooterCardsRowProps } from './types';

function FooterCards({ title, cardCopy }: FooterCardsRowProps) {
  return (
    <Wrapper>
      <BlurbWrapper>
        <Title data-test="footer-cards-title">
          <Text tag="p" weight="bold" color="white">{title}</Text>
        </Title>
      </BlurbWrapper>
      <Grid>
        {cardCopy.map((thisCopy, index) => (
          // This won't dynamically reload or anything, so this rule is actively not useful:
          // eslint-disable-next-line react/no-array-index-key
          <Items key={index}>
            <Card
              data-test={`footer-card-${index + 1}`}
              backgroundColor="white"
            >
              { RichTextConverter(thisCopy) }
            </Card>
          </Items>
        ))}
      </Grid>
    </Wrapper>
  );
}

export default FooterCards;
